
import Vue from "vue";
import GeneralScopeofWork from "../../components/GeneralScopeofWorkSheet"
import KPIPrintView from "./KPISheetPrintView"
import BudgetSheet from "../../components/BudgetSheet";
import PlanningSheet from "../../components/PlanningChecklist";
import Currencies from "../../utils/Currencies"
// import ScopeOfWork from "../Chart/Scope/ScopeOfWork";
import BudgetSheetProperties from "../../components/RightPaneComponents/BudgetSheetProperties";
import { HTTP } from '@/axios_api/http-common';
import UserProvisioning from "@/mixins/userProvisioning";
import BudgetTable from "../../components/BudgetTable.vue";
import DepartmentBudgetSheet from "../../components/BudgetComponents/DepartmentBudgetSheet.vue";
import DepartmentBudgetPerformance from "../../components/BudgetComponents/DepartmentBudgetPerformance.vue";
import LumpAFEBudget from "../../components/BudgetComponents/LumpAFEBudget.vue";
import LumpAFEPerformanceBudget from "../../components/BudgetComponents/LumpAFEPerformanceBudget.vue";
import ProjectBudgetSheet from "../../components/BudgetComponents/ProjectBudgetSheet.vue";
import ProjectCostPerformance from "../../components/BudgetComponents/ProjectCostPerformance.vue";
import CMultiSelect from '@/components/CMultiSelect.vue'

export default Vue.extend({
  name: "project-data-sheet",
  mixins: [UserProvisioning],
  props: ["projectId", "sequenceId","currentHeight","readOnlyView"],
  components: {
    "budget-sheet": BudgetSheet,
    "planning-sheet": PlanningSheet,
    // "scope-of-work": ScopeOfWork,
    "budget-sheet-properties": BudgetSheetProperties,
    "general-scope-Work":GeneralScopeofWork,
    "kpi-print-view":KPIPrintView,
    "budget-table": BudgetTable,
    "department-budget-sheet": DepartmentBudgetSheet,
    "department-budget-performance": DepartmentBudgetPerformance,
    "lump-afe-budget": LumpAFEBudget,
    "project-budget-sheet": ProjectBudgetSheet,
    "lump-afe-performance-budget": LumpAFEPerformanceBudget,
    "project-cost-performance": ProjectCostPerformance,
    'cmultiselect': CMultiSelect
  },
  data() {
    return {
      currentActualCost:0,
      tabIndex: 0,
      reloadDeptSheetTable: 0,
      reloadDeptPerfTable: 0,
      activeProjectConversionFactor:305,
      lineSplit: 1,
      selectedTemplate:null,
      showSplit: false,
      showLineSum: false,
      unitCost: false,
      dayRate: false,
      budgetLumpSum: true,
      selectedDepartmentId: 1,
      selectedOperationUnitId:0,
      selectedOperationUnitName:"",
      KPIPrintPreviewVisible: false,
      projectYear:new Date().getFullYear(),
      costOptions: [
        { value: 'ActualLumpSumCost', text: 'Actual Lump Sum Cost (K$)' },
        { value: 'ActualDailyCumulativeCost', text: 'Actual Daily Cumulative Cost (K$)' }
      ] as Array<any>,

      selectedCost: "ActualLumpSumCost",
      selectedBudgetTableCostOption: "ActualDailyCumulativeCost",
      selectedFrame: [] as Array<any>,

      budgetTemplateMergeOptions:[
        {text:"Merge All Budget Lines and ignore Sections",value:0},
        {text:"Duplicate Budget Lines in multiple Sections",value:1}
      ] as Array<any>,
      selectedActivities:[] as Array<any>,
      activity:{
        name:"",
        start:"",
        end:"",
        wellActivity:""
      },
      milestone:{
        name:"",
        start:"",
        code:"",
        end:"",
        description:"",
        parentActivityId:""
      },
      contract:{
        start:"",
        end:"",
        vendor:"",
        referenceNumber:"",
        title:""
      },
      departmentPayload: {
        id: 0,
        actualCost: 0,
        proposedBudget: 0,
        approvedBudget: 0,
        realignedBudget: 0,
      },
      currentUploadedBudgetFile:"",
      currentUploadedBudgetFileName:"",
      currentUploadedBudgetFileDescription:"",
      budgetUploadState:"IDLE",
      activeFileUploadAsscociatedModel:"",
      activeFileUploadMeta:""
    };
  },
  computed: {
    project():any{
      return this.$store.getters['projectModule/getProjectById'](this.projectId)
    },
    currencyOptions():Array<any>{
      let currencies: Array<any> = []
      for(var c in Currencies){
        currencies.push({text:c,value:c})
      }
      return currencies
    },
    getProjectIndexById():any{
        return this.$store.getters["projectModule/getProjectIndexById"](this.projectId)
    },
    sequence(): any {
      return this.$store.getters["sequencesModule/getSequence"](this.sequenceId);
    },
    allBudgetLineItems():any{
      return this.$store.getters["budgetLineModule/getAllBudgetLines"]
    },
    budgets():any{
      return this.$store.state.BudgetModule.budget
    },
    allActivitiesBudget(){
      let allActivitiesBudget = {budgetLines:[] as Array<any>}
      this.actvities.filter((a:any)=>this.selectedActivities.includes(a.id)).forEach((x: any, i:any) => {
        if(x.budget!=null&&x.budget){
          x.budget.budgetLines.forEach((bl:any,i:any) => {
            let budgetLineItem = this.allBudgetLineItems.find((bli:any) => bli.id == bl.lineItemId)
            if(budgetLineItem){
              const allActivitiesBudgetIndexToUpdate = allActivitiesBudget.budgetLines.findIndex((aabl:any) => aabl.lineItemId ==  bl.lineItemId)
              if(allActivitiesBudgetIndexToUpdate>-1){
                allActivitiesBudget.budgetLines[allActivitiesBudgetIndexToUpdate].lineValue+=x.budget.budgetLines[i].lineValue
              }else{
                //allActivitiesBudget.budgetLines.push({lineSplit:budgetLineItem.lineSplit,...x.budget.budgetLines[i]})
                allActivitiesBudget.budgetLines.push({lineSplit:budgetLineItem.lineSplit,lineItemId:x.budget.budgetLines[i].lineItemId,lineValue:x.budget.budgetLines[i].lineValue,id:x.budget.budgetLines[i].id})
              }
            }
          });
        }
      })
      return allActivitiesBudget
    },
    
    columns(): Array<any> {

      let columnsToReturn = [] as Array<any>

      // columnsToReturn.push({id:this.previousYearQuarterTwoCompletionValues.meta,hasHeader:true,header:this.projectYear-1+" Q2",headerSpan:4,name:"Completion %",budget:this.previousYearQuarterTwoCompletionValues,editable:true,ignoreInSum:true})
      // columnsToReturn.push({id:this.previousYearQuarterTwoNairaValue.meta,skipHeader:true,name:"KNGN", budget:this.previousYearQuarterTwoNairaValue,ignoreInSum:true})
      // columnsToReturn.push({id:this.previousYearQuarterTwoDollarValue.meta,skipHeader:true,name:"K$",budget:this.previousYearQuarterTwoDollarValue,ignoreInSum:true})
      // columnsToReturn.push({id:this.previousYearQuarterTwoBudget.meta,skipHeader:true,name:"F(K$)",budget:this.previousYearQuarterTwoBudget,editable:true,ignoreInSum:true})
         
      // columnsToReturn.push({id:this.previousYearQuarterFourCompletionValues.meta,hasHeader:true,header:this.projectYear-1+" Q4",headerSpan:4,name:"Completion %",budget:this.previousYearQuarterFourCompletionValues,editable:true,ignoreInSum:true})
      // columnsToReturn.push({id:this.previousYearQuarterFourNairaValue.meta,skipHeader:true,name:"KNGN", budget:this.previousYearQuarterFourNairaValue,ignoreInSum:true})
      // columnsToReturn.push({id:this.previousYearQuarterFourDollarValue.meta,skipHeader:true,name:"K$",budget:this.previousYearQuarterFourDollarValue,ignoreInSum:true})
      // columnsToReturn.push({id:this.previousYearQuarterFourBudget.meta,skipHeader:true,name:"F(K$)",budget:this.previousYearQuarterFourBudget,editable:true,ignoreInSum:true})
       
      // columnsToReturn.push({id:this.currentYearCompletionValues.meta,hasHeader:true,header:this.projectYear+" Proposed Budget",headerSpan:4,name:"Completion %",budget:this.currentYearCompletionValues,editable:true,ignoreInSum:true})
      // columnsToReturn.push({id:this.currentYearNairaValue.meta,skipHeader:true,name:"KNGN", budget:this.currentYearNairaValue,ignoreInSum:true})
      columnsToReturn.push({id:this.currentYearNairaValue.meta,hasHeader:true,header:this.projectYear+" Proposed Budget",headerSpan:3,name:"KNGN", budget:this.currentYearNairaValue,ignoreInSum:true})
      columnsToReturn.push({id:this.currentYearDollarValue.meta,skipHeader:true,name:"K$",budget:this.currentYearDollarValue,ignoreInSum:true})
      columnsToReturn.push({id:this.currentYearBudget.meta,skipHeader:true,name:"F(K$)",budget:this.currentYearBudget,editable:true,ignoreInSum:true})

      columnsToReturn.push({id: "nvAP",hasHeader:true,header:this.projectYear+" Approved Budget",headerSpan:this.selectedActivities.length+2,name: "KNGN",editable:false,budget:this.nairaBudget,ignoreInSum:true})
      columnsToReturn.push({id: "dvAP",skipHeader:true,name: "K$",editable:false,budget:this.dollarBudget,ignoreInSum:true})

      if (this.budgetLumpSum){
        this.actvities.filter((a:any)=>this.selectedActivities.includes(a.id)).forEach((x: any, i:any) => {
          columnsToReturn.push({
            id: x.id,
            skipHeader:true,
            name: "F(K$)",
            editable:true,
            budget:x.budget==null?{budgetLines:[]}:x.budget
          })
        })
        //columnsToReturn.push({id:this.currentYearReAllignedNairaValue.meta,hasHeader:true,header:"2020 Re-Alligned Budget",headerSpan:3,name:"SN'000",budget:this.currentYearReAllignedNairaValue,ignoreInSum:true})
      }else{
        let allMilestones: Array<any> = [];
        this.actvities.forEach((a: any) => {
          a.milestones.forEach((m: any) => {
            columnsToReturn.push(
              {id:m.id,name:m.name,budget:m.budget==null?{budgetLines:[]}:m.budget,editable:true}
            );
          });
        });
      } 

      columnsToReturn.push({id:this.currentYearReAllignedNairaValue.meta,hasHeader:true,header:this.projectYear+" Re-Alligned Budget",headerSpan:3,name:"KNGN",budget:this.currentYearReAllignedNairaValue,ignoreInSum:true})
      columnsToReturn.push({id:this.currentYearReaAllignedDollarValue.meta,skipHeader:true,name:"K$",budget:this.currentYearReaAllignedDollarValue,ignoreInSum:true})
      columnsToReturn.push({id:this.currentYearReAllignedBudget.meta,skipHeader:true,name:"F(K$)", budget:this.currentYearReAllignedBudget,editable:true,ignoreInSum:true})

      return columnsToReturn;
    },

    budgetPerformanceColumns():Array<any>{
      let columnsToReturn:Array<any> = []

      let planColumn = {name:"Plan (K$)",id:"1",budget: {budgetLines:[] as Array<any>}}
      let actualColumn = {name:"Actual Lump Sum Cost (K$)",editable:true,id:"2",budget:{budgetLines:[] as Array<any>}}
      let varianceColumn = {name:"Variance (K$)",id:"3",budget:{budgetLines:[] as Array<any>}}
      let actualCummulativeColumn = {name:"Actual Daily Cumulative Cost (K$)",id:"4",budget:{budgetLines:[] as Array<any>}}

      //first get all line items
      let allLineItems:Array<any> = []
      if(this.rowsData.groupExtractor==undefined){
        allLineItems = this.rowsData.rows
      }else{
        this.rowsData.rows.forEach((s:any) => {
          allLineItems.push(...this.rowsData.groupExtractor(s).rows)
        });
      }

      planColumn.budget.budgetLines = allLineItems.map((l:any)=>({lineItemId:l.id,lineValue:0,lineItemName:l.lineItem}))
      actualColumn.budget.budgetLines = allLineItems.map((l:any)=>({lineItemId:l.id,lineValue:0,lineItemName:l.lineItem}))
      actualCummulativeColumn.budget.budgetLines = allLineItems.map((l:any)=>({lineItemId:l.id,lineValue:0,lineItemName:l.lineItem}))
      varianceColumn.budget.budgetLines = allLineItems.map((l:any)=>({lineItemId:l.id,lineValue:0,lineItemName:l.lineItem}))
      //end of getting all line items

      //compute line item values
      this.actvities.forEach((a:any,index:number) => {
        const reportCosts = this.ddrs
          .filter((report: any) => 
            report &&
            Array.isArray(report.activityLog) &&
            Array.isArray(report.cost && report.cost.budgetLines)
          )
          .flatMap((report: any) => 
            report.activityLog
              .filter((al: any) => al.activityInProjectId === a.id)
              .flatMap((al: any) => {
                const filteredBudgetLines = report.cost.budgetLines.filter((bl: any) => bl.activityId === al.activityId);
                return filteredBudgetLines.length > 0 
                  ? [{ ...report.cost, budgetLines: filteredBudgetLines }] 
                  : [];
              })
          );

        //set the actual column id to id of the first activity
        if(index==0){
          actualColumn.id = a.id
        }
        //compute plan and actual
        allLineItems.forEach((l:any,index:any) => {
          if(a.budget!=null){
            let retrievedLine = a.budget.budgetLines.find((bl:any)=>bl.lineItemId==l.id)
            if(retrievedLine)planColumn.budget.budgetLines[index].lineValue+=retrievedLine.lineValue
          }
          if(a.actualCost!=null){
            let retrievedLine = a.actualCost.budgetLines.find((bl:any)=>bl.lineItemId==l.id)
            if(retrievedLine)actualColumn.budget.budgetLines[index].lineValue+=Number(retrievedLine.lineValue)
          }
          

          const actualDailyBudget = Array.isArray(reportCosts) && reportCosts.length
            ? reportCosts
                .filter(x => x && x.budgetLines && x.budgetLines.some((bl: any) => bl.lineItemId == l.id))
                .map((x: any) => {
                  const budgetLine = x.budgetLines.find((bl: any) => bl.lineItemId == l.id);
                  return budgetLine && budgetLine.lineValue ? budgetLine.lineValue : 0;
                })
                .reduce((sum, value) => sum + value, 0)
            : 0;
          
          actualCummulativeColumn.budget.budgetLines[index].lineValue += actualDailyBudget;

          // if(a.actualDailyCummulativeCost!=null){
          //   let retrievedLine = a.actualDailyCummulativeCost.budgetLines.find((bl:any)=>bl.lineItemId==l.id)
          //   if(retrievedLine)actualCummulativeColumn.budget.budgetLines[index].lineValue+=Number(retrievedLine.lineValue)
          // }
        })

      });



      //compute variance
      allLineItems.forEach((l:any,index:any) => {
        const variance = this.selectedCost === "ActualDailyCumulativeCost" ?  actualCummulativeColumn.budget.budgetLines[index].lineValue : actualColumn.budget.budgetLines[index].lineValue
        varianceColumn.budget.budgetLines[index].lineValue = planColumn.budget.budgetLines[index].lineValue - variance;
      })

      columnsToReturn.push(planColumn)
      columnsToReturn.push(actualColumn)
      columnsToReturn.push(actualCummulativeColumn)
      columnsToReturn.push(varianceColumn)
      return columnsToReturn
    },

    nairaBudget(): any{
      return {budgetLines:this.allActivitiesBudget.budgetLines.map((aabl:any) => ({lineValue:aabl.lineValue*this.activeProjectConversionFactor*(1-aabl.lineSplit),id:aabl.id,lineItemId:aabl.lineItemId}))}
    },

    dollarBudget(): any{
      return {budgetLines:this.allActivitiesBudget.budgetLines.map((aabl:any) => ({lineValue:aabl.lineValue*aabl.lineSplit,id:aabl.id,lineItemId:aabl.lineItemId}))}
    },

    rowsData():any{
      let result:any = {rows:[],groupExtractor:undefined}
      result.groupExtractor = (s:any)=>({key:s.id,label:s.sectionName,rows:s.budgetLineItems})
      let budgetTemplate = this.getBudgetTemplates && this.getBudgetTemplates.length ? this.getBudgetTemplates.find((thisBudgetTeplate:any) => thisBudgetTeplate.id == this.selectedTemplate) : null;
      if(budgetTemplate && budgetTemplate != null) result.rows =  budgetTemplate.sections
      return result
    },
    
    getSortedActivities():any {
      return this.$store.getters["ActivityModule/getNewActivitiesForProject"](this.projectId);
    },

    projectCostRowsData():any{
      let rows: Array<any> = []
      let budgetTemplate = this.getBudgetTemplates && this.getBudgetTemplates.length ? this.getBudgetTemplates.find((thisBudgetTeplate:any) => thisBudgetTeplate.id == this.selectedTemplate) : null;
      if(!budgetTemplate && budgetTemplate == null) return [];
      let allLineItems:Array<any> = []
        budgetTemplate.sections.forEach((s: any) => {
          s.budgetLineItems.forEach((l: any) => {
              allLineItems.push({ ...l, sectionName: s.sectionName });
          });
      });

      const currentBudget = {
          budgetTemplateId: budgetTemplate.id,
          budgetLines: allLineItems.map((l: any) => ({
              lineItemId: l.id,
              lineSplit: l.lineSplit,
              lineValue: 0,
              lineItemName: l.lineItem,
              sectionName: l.sectionName,
          })),
          projectId: this.project.id,
      };

      allLineItems.forEach((item: any) => {
        const approvedBudgetLine = !this.project.approvedBudget || this.project.approvedBudget === null ? currentBudget.budgetLines.find((l: any) => l.lineItemId == item.id) : this.project.approvedBudget.budgetLines.find((l: any) => l.lineItemId == item.id);
        const proposedBudgetLine = !this.project.proposedBudget || this.project.proposedBudget === null ? currentBudget.budgetLines.find((l: any) => l.lineItemId == item.id) : this.project.proposedBudget.budgetLines.find((l: any) => l.lineItemId == item.id);
        const realignedBudgetLine = !this.project.realignedBudget || this.project.realignedBudget === null ? currentBudget.budgetLines.find((l: any) => l.lineItemId == item.id) : this.project.realignedBudget.budgetLines.find((l: any) => l.lineItemId == item.id);

        rows.push({
          id: item.id,
          lineItem: item.lineItem,
          sectionName: item.sectionName,
          lineSplit: item.lineSplit,
          approvedBudget: approvedBudgetLine ? approvedBudgetLine.lineValue : 0,
          proposedBudget: proposedBudgetLine ? proposedBudgetLine.lineValue : 0,
          realignedBudget: realignedBudgetLine ? realignedBudgetLine.lineValue : 0,
          projectId: this.project.id,
          budgetTemplateId: budgetTemplate.id,
        });
      });

      return rows;
    },

    lumpSumAFERowsData():any{      
      return [{
        approvedAFEBudget: this.project.approvedAFEBudget ? this.project.approvedAFEBudget : 0,
        proposedAFEBudget: this.project.proposedAFEBudget ? this.project.proposedAFEBudget : 0,
        realignedAFEBudget: this.project.realignedAFEBudget ? this.project.realignedAFEBudget : 0,
        afeCost: this.project.afeCost ? this.project.afeCost : 0,
      }];
    },

    departmentRowsData():any{
      let budget = {
        approvedBudget: 0,
        proposedBudget: 0,
        realignedBudget: 0,
        actualCost: 0,
        departmentId: this.selectedDepartmentId,
      };
      const department = this.departments.find((d:any) => d.id == this.selectedDepartmentId);
      if (!department) return [];
      
      if (this.project.departmentBudgets && this.project.departmentBudgets.length) {
        const departmentBudget = this.project.departmentBudgets.find((d: any) => d.departmentId == this.selectedDepartmentId);
        if (departmentBudget) {
          return [{
            department: department.name,
            departmentId: this.selectedDepartmentId,
            approvedBudget: departmentBudget.approvedBudget ? departmentBudget.approvedBudget : 0,
            actualCost: departmentBudget.actualCost ? departmentBudget.actualCost : 0,
            proposedBudget: departmentBudget.proposedBudget ? departmentBudget.proposedBudget : 0,
            realignedBudget: departmentBudget.realignedBudget ? departmentBudget.realignedBudget : 0,
          }];
        }
      }
      return [{
        department: department.name,
        departmentId: this.selectedDepartmentId,
        approvedBudget: budget.approvedBudget,
        actualCost: budget.actualCost,
        proposedBudget: budget.proposedBudget,
        realignedBudget: budget.realignedBudget,
      }];
    },

    projectCostPerformanceRowsData():any{
      let rows: Array<any> = []
      let budgetTemplate = this.getBudgetTemplates && this.getBudgetTemplates.length ? this.getBudgetTemplates.find((thisBudgetTeplate:any) => thisBudgetTeplate.id == this.selectedTemplate) : null;
      if(!budgetTemplate && budgetTemplate == null) return [];
      let allLineItems:Array<any> = []
        budgetTemplate.sections.forEach((s: any) => {
          s.budgetLineItems.forEach((l: any) => {
              allLineItems.push({ ...l, sectionName: s.sectionName });
          });
      });

      const currentBudget = {
          budgetTemplateId: budgetTemplate.id,
          budgetLines: allLineItems.map((l: any) => ({
              lineItemId: l.id,
              lineSplit: l.lineSplit,
              lineValue: 0,
              lineItemName: l.lineItem,
              sectionName: l.sectionName,
          })),
          projectId: this.project.id,
      };

      const reports = this.ddrs.map((report: any) => {
        if (report) {
          return report.projectCost;
        }
        return null;
      });

      allLineItems.forEach((item: any) => {        
        const planBudgetLine = !this.project.approvedBudget || this.project.approvedBudget === null ? currentBudget.budgetLines.find((l: any) => l.lineItemId == item.id) : this.project.approvedBudget.budgetLines.find((l: any) => l.lineItemId == item.id);
        const actualBudgetLine = !this.project.actualBudgetCost || this.project.actualBudgetCost === null ? currentBudget.budgetLines.find((l: any) => l.lineItemId == item.id) : this.project.actualBudgetCost.budgetLines.find((l: any) => l.lineItemId == item.id);
        const actualDailyBudget = Array.isArray(reports) && reports.length
          ? reports
              .filter(x => x && x.budgetLines && x.budgetLines.some((bl: any) => bl.lineItemId == item.id))
              .map((x: any) => {
                const budgetLine = x.budgetLines.find((bl: any) => bl.lineItemId == item.id);
                return budgetLine && budgetLine.lineValue ? budgetLine.lineValue : 0;
              })
              .reduce((sum, value) => sum + value, 0)
          : 0;

        const varianceOption = this.selectedCost === "ActualDailyCumulativeCost" 
          ? actualDailyBudget 
          : actualBudgetLine ? actualBudgetLine.lineValue : 0;

        rows.push({
          id: item.id,
          lineItem: item.lineItem,
          sectionName: item.sectionName,
          lineSplit: item.lineSplit,
          plan: planBudgetLine ? planBudgetLine.lineValue : 0,
          actualBudgetCost: actualBudgetLine ? actualBudgetLine.lineValue : 0,
          actualDailyBudgetCost: actualDailyBudget,
          variance: planBudgetLine ? planBudgetLine.lineValue - (varianceOption ? varianceOption : 0) : 0,
          projectId: this.project.id,
          budgetTemplateId: budgetTemplate.id,
        });
      });

      return rows;
    },

    lumpSumAFEPerformanceRowsData():any{
      const reports = this.ddrs.map((report: any) => {
        if (report.projectId) {
          return report.dailyTotalCost;
        }
        return null;
      });

      const totalDailyCost = reports.reduce((sum, value) => sum + value, 0);
      
      const varianceOption = this.selectedCost === "ActualDailyCumulativeCost" 
        ? totalDailyCost 
        : (this.project.afeCost ? this.project.afeCost : 0);

      return [{
        plan: Number(this.project.approvedAFEBudget ? this.project.approvedAFEBudget.toFixed(2) : 0),
        afeCost: Number(this.project.afeCost ? this.project.afeCost.toFixed(2) : 0),
        actualDailyCumulativeCost: Number(totalDailyCost && totalDailyCost != 0 && totalDailyCost != null ? totalDailyCost.toFixed(2) : 0),
        variance: Number(((this.project.approvedAFEBudget ? this.project.approvedAFEBudget : 0) - varianceOption).toFixed(2))
      }];
    },

    departmentPerformanceRowsData():any{
      let actualCost: number = 0;
      let planCost: number = 0;
      const department = this.departments.find((d:any) => d.id == this.selectedDepartmentId);
      if (!department) return [];
      
      if (this.project.departmentBudgets && this.project.departmentBudgets.length) {
        const departmentBudget = this.project.departmentBudgets.find((d: any) => d.departmentId == this.selectedDepartmentId);
        if (departmentBudget) {
          actualCost = departmentBudget.actualCost ? departmentBudget.actualCost : 0;
          planCost = departmentBudget.approvedBudget ? departmentBudget.approvedBudget : 0;
        }
      }

      const allActivityIdsSet = new Set(
        this.ddrs
          .flatMap((report: any) => report.activityLog || [])
          .map((log: any) => log.activityInProjectId) || []);

      const activities = this.getSortedActivities
        .filter((a: any) => allActivityIdsSet
        .has(a.id) && a.departmentId == this.selectedDepartmentId)
        .map((a: any) => a.id);

      const reports = this.ddrs.filter((report: any) => {
        if (report.activityLog && report.activityLog.length) {
          return report.activityLog.some((x: any) => activities.includes(x.activityInProjectId));
        }
        return null;
      });

      const allDailyCost = reports.flatMap((report: any) => {
        if (report.afeSummary && report.afeSummary.dailyCost) {
          return report.afeSummary.dailyCost;
        } 
        return [];
      });

      const totalDailyCost = allDailyCost.reduce((sum, value) => sum + value, 0);
      
      const varianceOption = this.selectedCost === "ActualDailyCumulativeCost" 
        ? totalDailyCost   
        : actualCost;
        
      return [{
        department: department.name,
        departmentId: this.selectedDepartmentId,
        plan: planCost,
        actualCost: actualCost,
        actualDailyCumulativeCost: Number(totalDailyCost ? totalDailyCost : 0),
        variance: Number((planCost - varianceOption))
      }];
    },

    getDepartmentOptions(): Array<any> {
        return this.$store.getters['departmentModule/getAllDepartments']
    },
    
    departments(): any {
      if (this.sequence !== undefined && this.sequence.departments) {
        const deptIds = this.sequence.departments.map((d:any) => d.id);
        const departments = this.getDepartmentOptions.filter(d => deptIds.includes(d.id));
        return departments;
      }
      return [];
    },
    milestones():Array<any>{
      let milestonesToReturn:Array<any> = []
      this.actvities.forEach(a => {
        a.milestones.forEach((m:any) => {
          milestonesToReturn.push(m)
        });
      })
      return milestonesToReturn;
    },
    actvities(): Array<any> {
      return this.$store.getters["ActivityModule/getActivitiesForProject"](this.projectId).filter(
        (x: any) => (x.departmentId == this.selectedDepartmentId)&&(x.operationUnitId==this.selectedOperationUnitId)
      );
    },
    milestoneActivity():any{
      return this.$store.dispatch("MilestoneModule/getMilestonesForActivity")
    },
    activityOptions():Array<any>{
      return this.actvities.map(a => ({text:a.wellActivity.name,value:a.id}))
    },
    getWellActivities ():Array<any> {
      return this.$store.getters['wellactivitiesModule/getWellOperations']
    },
    getWellActivityOptions ():Array<any> {
      return this.getWellActivities.map((data: any) => {
        return {text: data.name, value: data.id}
      })
    },
    budgetTemplateOptions(): any {
      if (this.project.costOption === "ProjectCost") {
        return this.getBudgetTemplates && this.getBudgetTemplates.length ? this.getBudgetTemplates.filter((bt:any) => bt.departmentId == null ).map((thisBudgetTemplate: any) => ({
          value: thisBudgetTemplate.id,
          text: thisBudgetTemplate.templateName,
        })) : [];
      }
      return this.getBudgetTemplates && this.getBudgetTemplates.length ? this.getBudgetTemplates.filter((bt:any) => bt.departmentId == this.selectedDepartmentId ).map((thisBudgetTemplate: any) => ({
        value: thisBudgetTemplate.id,
        text: thisBudgetTemplate.templateName,
      })) : [];
    },
    activeTemplates():Array<any>{
      let templatesToReturn = [] as Array<any>
      this.actvities.filter(a => this.selectedActivities.includes(a.id)).forEach(a => {
        if(a.budget != null){
          if(!templatesToReturn.includes(a.budget.budgetTemplateId))templatesToReturn.push(a.budget.budgetTemplateId)
        }
      })
      return templatesToReturn;
    },
    
    previousYearQuarterTwoCompletionValues():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ2C"
      let budget = this.$store.getters["BudgetModule/getByMeta"](meta)
      if(budget) return budget;
      return {budgetLines:[],meta}
    },
    previousYearQuarterTwoBudget():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ2B"
      let budget = this.$store.getters["BudgetModule/getByMeta"](meta)
      if(budget){
        budget.budgetLines.forEach((bl:any,index:number) => {
          let budgetLineItem = this.allBudgetLineItems.find((bli:any) => bli.id == bl.lineItemId)
          if(budgetLineItem){
            budget.budgetLines[index].lineSplit = budgetLineItem.lineSplit
          }
        });
        return budget
      }
      return {budgetLines:[],meta}
    },
    previousYearQuarterTwoNairaValue():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ2BN"
      let budgetLines = this.previousYearQuarterTwoBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*(1-b.lineSplit)*this.activeProjectConversionFactor),lineItemId:b.lineItemId}))
      return {budgetLines,meta}
    },
    previousYearQuarterTwoDollarValue():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ2BD"
      let budgetLines = this.previousYearQuarterTwoBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*b.lineSplit),lineItemId:b.lineItemId}))
      return {budgetLines,meta}
    },

    previousYearQuarterFourCompletionValues():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ4C"
      let budget = this.$store.getters["BudgetModule/getByMeta"](meta)
      if(budget) return budget;
      return {budgetLines:[],meta}
    },
    previousYearQuarterFourBudget():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ4B"
      let budget = this.$store.getters["BudgetModule/getByMeta"](meta)
      if(budget){
        budget.budgetLines.forEach((bl:any,index:number) => {
          let budgetLineItem = this.allBudgetLineItems.find((bli:any) => bli.id == bl.lineItemId)
          if(budgetLineItem){
            budget.budgetLines[index].lineSplit = budgetLineItem.lineSplit
          }
        });
        return budget
      }
      return {budgetLines:[],meta}
    },
    previousYearQuarterFourNairaValue():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ4BN"
      let budgetLines = this.previousYearQuarterFourBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*(1-b.lineSplit)*this.activeProjectConversionFactor),lineItemId:b.lineItemId}))
      return {budgetLines,meta}
    },
    previousYearQuarterFourDollarValue():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ4BD"
      let budgetLines = this.previousYearQuarterFourBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*b.lineSplit),lineItemId:b.lineItemId}))
      return {budgetLines,meta}
    },

    currentYearCompletionValues():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYC"
      let budget = this.$store.getters["BudgetModule/getByMeta"](meta)
      if(budget) return budget;
      return {budgetLines:[],meta}
    },
    currentYearBudget():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYB"
      let budget = this.$store.getters["BudgetModule/getByMeta"](meta)
      if(budget){
        budget.budgetLines.forEach((bl:any,index:number) => {
          let budgetLineItem = this.allBudgetLineItems.find((bli:any) => bli.id == bl.lineItemId)
          if(budgetLineItem){
            budget.budgetLines[index].lineSplit = budgetLineItem.lineSplit
          }
        });
        return budget
      }
      return {budgetLines:[],meta}
    },
    currentYearNairaValue():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYBN"
      let budgetLines = this.currentYearBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*(1-b.lineSplit)*this.activeProjectConversionFactor),lineItemId:b.lineItemId}))
      return {budgetLines,meta}
    },
    currentYearDollarValue():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYBD"
      let budgetLines = this.currentYearBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*b.lineSplit),lineItemId:b.lineItemId}))
      return {budgetLines,meta}
    },

    currentYearReAllignedBudget():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYRB"
      let budget = this.$store.getters["BudgetModule/getByMeta"](meta)
      if(budget){
        budget.budgetLines.forEach((bl:any,index:number) => {
          let budgetLineItem = this.allBudgetLineItems.find((bli:any) => bli.id == bl.lineItemId)
          if(budgetLineItem){
            budget.budgetLines[index].lineSplit = budgetLineItem.lineSplit
          }
        });
        return budget
      }
      return {budgetLines:[],meta}
    },
    currentYearReAllignedNairaValue():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYRBN"
      let budgetLines = this.currentYearReAllignedBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*(1-b.lineSplit)*this.activeProjectConversionFactor),lineItemId:b.lineItemId}))
      return {budgetLines,meta}
    },
    currentYearReaAllignedDollarValue():any{
      let meta = this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYRBD"
      let budgetLines = this.currentYearReAllignedBudget.budgetLines.map((b:any) => ({lineValue:(b.lineValue*(b.lineSplit)),lineItemId:b.lineItemId}))
      return {budgetLines,meta}
    },

    files():any{
      return this.$store.getters["FileModule/filteredFiles"](this.projectId,this.selectedDepartmentId,this.selectedOperationUnitId,this.activeFileUploadAsscociatedModel,this.activeFileUploadMeta)
    },
    selectedActivity():any {
        return this.$store.getters['ActivityModule/getActiveActivity'];
    },
    ddrs(): Array<any> {
      return this.$store.getters["DailyReportModule/getReportsForProject"](this.projectId);
    },
    getBudgetTemplates(): Array<any> {
      return this.$store.getters["budgetTemplateModule/getAllTemplates"]
    },
    // lineItemsTableData() {
    //   let result:any = {rows:[],groupExtractor:undefined}
    //   let budgetTemplatesToProcess:Array<any> = []
    //   const activities = this.sortedActivitiesForProject();

    //   activities.forEach((activity:any) => {
    //     const dept = this.departments.find((d:any) => d.id === activity.departmentId);
    //     if (!dept) return;
    //     const operationUnit = dept.operationUnits.find((o:any) => o.id === activity.operationUnitId)
    //     budgetTemplatesToProcess.push({
    //       activityId: activity.id,
    //       department: dept.name,
    //       departmentId: dept.id,
    //       operationUnit: operationUnit ? operationUnit.name : "",
    //       operationUnitId: operationUnit ? operationUnit.id : "-1",
    //       planBudgetSection: activity.budget !== null ? this.getBudgetTemplates.find((b:any) => b.id == activity.budget.budgetTemplateId) : null,
    //       planCost: activity.budget,
    //       actualCost: activity.actualCost,
    //       lumpSumCost: activity.lumpSumCost,
    //       actualDailyCummulativeCost: activity.actualDailyCummulativeCost,
    //     })
    //   })
    //   if(budgetTemplatesToProcess.length>0){
    //     budgetTemplatesToProcess.forEach((budgetTemplate:any)=>{
    //       if (budgetTemplate.planBudgetSection !== undefined && budgetTemplate.planBudgetSection !== null) {
    //         budgetTemplate.planBudgetSection.sections.forEach((section: any)=>{        
    //           result.rows.push({
    //             activityId: budgetTemplate.activityId,
    //             department: budgetTemplate.department,
    //             operationunit: budgetTemplate.operationUnit,
    //             planBudgetSection: section,
    //             actualDailyCummulativeBudgetSection: section,
    //             actualSection: section,
    //             planCost: budgetTemplate.planCost,
    //             actualCost: budgetTemplate.actualCost,
    //             lumpSumCost: budgetTemplate.lumpSumCost,
    //             actualDailyCummulativeCost: budgetTemplate.actualDailyCummulativeCost,
    //           })
    //         })
    //       }
    //     })
    //   }
    //   return result;
    // },

    lineItemsTableData() {
      let result:any = {rows:[],groupExtractor:undefined}
      let budgetTemplatesToProcess:Array<any> = []
      const activities = this.sortedActivitiesForProject();
      
      activities.forEach((activity:any) => {
        if (!activity.budget) return;
        let actualCummulativeColumn = {name:"Actual Daily Cumulative Cost (K$)",id:"4", budgetLines:[] as Array<any>}
        let budgetTemplate = this.getBudgetTemplates && this.getBudgetTemplates.length ? this.getBudgetTemplates.find((thisBudgetTeplate:any) => thisBudgetTeplate.id == activity.budget.budgetTemplateId) : null;
        if(!budgetTemplate && budgetTemplate == null) return [];
        let allLineItems:Array<any> = []
          budgetTemplate.sections.forEach((s: any) => {
            s.budgetLineItems.forEach((l: any) => {
                allLineItems.push({ ...l, sectionName: s.sectionName });
            });
        });

        actualCummulativeColumn.budgetLines = allLineItems.map((l:any)=>({lineItemId:l.id,lineValue:0,lineItemName:l.lineItem }))

        const reportCosts = this.ddrs
          .filter((report: any) => 
            report &&
            Array.isArray(report.activityLog) &&
            Array.isArray(report.cost && report.cost.budgetLines)
          )
          .flatMap((report: any) => 
            report.activityLog
              .filter((al: any) => al.activityInProjectId === activity.id)
              .flatMap((al: any) => {
                const filteredBudgetLines = report.cost.budgetLines.filter((bl: any) => bl.activityId === al.activityId);
                const milestone = this.getMilestoneById(al.activityId)
                return filteredBudgetLines.length > 0 
                  ? [{ ...report.cost, budgetLines: filteredBudgetLines, milestone: milestone ? milestone.name : '' }] 
                  : [];
              })
          );

        const dept = this.departments.find((d:any) => d.id === activity.departmentId);
        if (!dept) return;
        const operationUnit = dept.operationUnits.find((o:any) => o.id === activity.operationUnitId)

        allLineItems.forEach((l:any,index:any) => {
          const actualDailyBudget = Array.isArray(reportCosts) && reportCosts.length
              ? reportCosts
                  .filter(x => x && x.budgetLines && x.budgetLines.some((bl: any) => bl.lineItemId == l.id))
                  .map((x: any) => {
                    const budgetLine = x.budgetLines.find((bl: any) => bl.lineItemId == l.id);
                    return budgetLine && budgetLine.lineValue ? budgetLine.lineValue : 0;
                  })
                  .reduce((sum, value) => sum + value, 0)
              : 0;
            
          actualCummulativeColumn.budgetLines[index].lineValue += actualDailyBudget;
        })

        const milestone = Array.isArray(reportCosts) && reportCosts.length ? reportCosts.find(x => x.milestone !== '') : null;
        budgetTemplatesToProcess.push({
          activityId: activity.id,
          department: dept.name,
          milestone: milestone != null ? milestone.milestone : '',
          departmentId: dept.id,
          operationUnit: operationUnit ? operationUnit.name : "",
          operationUnitId: operationUnit ? operationUnit.id : "-1",
          planBudgetSection: activity.budget !== null ? this.getBudgetTemplates.find((b:any) => b.id == activity.budget.budgetTemplateId) : null,
          planCost: activity.budget,
          actualCost: activity.actualCost,
          lumpSumCost: activity.lumpSumCost,
          actualDailyCummulativeCost: actualCummulativeColumn,
        })
      })
      if(budgetTemplatesToProcess.length>0){
        budgetTemplatesToProcess.forEach((budgetTemplate:any)=>{
          if (budgetTemplate.planBudgetSection !== undefined && budgetTemplate.planBudgetSection !== null) {
            budgetTemplate.planBudgetSection.sections.forEach((section: any)=>{        
              result.rows.push({
                activityId: budgetTemplate.activityId,
                department: budgetTemplate.department,
                milestone: budgetTemplate.milestone,
                operationunit: budgetTemplate.operationUnit,
                planBudgetSection: section,
                actualDailyCummulativeBudgetSection: section,
                actualSection: section,
                planCost: budgetTemplate.planCost,
                actualCost: budgetTemplate.actualCost,
                lumpSumCost: budgetTemplate.lumpSumCost,
                actualDailyCummulativeCost: budgetTemplate.actualDailyCummulativeCost,
              })
            })
          }
        })
      }
      return result;
    },

    departmentsTableData() {
      let result:any = {rows:[],groupExtractor:undefined}
      this.departments.forEach((department: any) => {
        let actualCost: number = 0;
        let planCost: number = 0;
        
        if (this.project.departmentBudgets && this.project.departmentBudgets.length) {
          const departmentBudget = this.project.departmentBudgets.find((d: any) => d.departmentId == department.id);
          if (departmentBudget) {
            actualCost = departmentBudget.actualCost ? departmentBudget.actualCost : 0;
            planCost = departmentBudget.approvedBudget ? departmentBudget.approvedBudget : 0;
          }
        }
        const allActivityIdsSet = new Set(
        this.ddrs
          .flatMap((report: any) => report.activityLog || [])
          .map((log: any) => log.activityInProjectId) || []);

        const activities = this.getSortedActivities
          .filter((a: any) => allActivityIdsSet
          .has(a.id) && a.departmentId == department.id)
          .map((a: any) => a.id);

        const reports = this.ddrs.filter((report: any) => {
          if (report.activityLog && report.activityLog.length) {
            return report.activityLog.some((x: any) => activities.includes(x.activityInProjectId));
          }
          return null;
        });

        const allDailyCost = reports.flatMap((report: any) => {
          if (report.afeSummary && report.afeSummary.dailyCost) {
            return report.afeSummary.dailyCost;
          } 
          return [];
        });

        const totalDailyCost = allDailyCost.reduce((sum, value) => sum + value, 0);

        const varianceOption = this.selectedBudgetTableCostOption === "ActualDailyCumulativeCost" 
        ? totalDailyCost
        : actualCost;   

        result.rows.push({
          department: department.name,
          departmentId: department.id,
          plan: planCost,
          actualCost: actualCost,
          actualDailyCumulativeCost: Number(totalDailyCost ? totalDailyCost : 0),
          variance: Number((planCost - varianceOption))
        });
      });
      return result;
    },

    projects(): Array<any> {
      return this.$store.getters['projectModule/getProjectsForSequence'](this.sequenceId)
    },

    projectCostTableData():any{
      let rows: Array<any> = []
      let budgetTemplate = this.getBudgetTemplates && this.getBudgetTemplates.length ? this.getBudgetTemplates.find((thisBudgetTeplate:any) => thisBudgetTeplate.id == this.selectedTemplate) : null;
      if(!budgetTemplate && budgetTemplate == null) return [];
      let allLineItems:Array<any> = []
        budgetTemplate.sections.forEach((s: any) => {
          s.budgetLineItems.forEach((l: any) => {
              allLineItems.push({ ...l, sectionName: s.sectionName });
          });
      });

      const currentBudget = {
          budgetTemplateId: budgetTemplate.id,
          budgetLines: allLineItems.map((l: any) => ({
              lineItemId: l.id,
              lineSplit: l.lineSplit,
              lineValue: 0,
              lineItemName: l.lineItem,
              sectionName: l.sectionName,
          })),
          projectId: this.project.id,
      };

      const reports = this.ddrs.map((report: any) => {
        if (report) {
          return report.projectCost;
        }
        return null;
      });

      allLineItems.forEach((item: any) => {
        const planBudgetLine = !this.project.approvedBudget || this.project.approvedBudget === null ? currentBudget.budgetLines.find((l: any) => l.lineItemId == item.id) : this.project.approvedBudget.budgetLines.find((l: any) => l.lineItemId == item.id);
        const actualBudgetLine = !this.project.actualBudgetCost || this.project.actualBudgetCost === null ? currentBudget.budgetLines.find((l: any) => l.lineItemId == item.id) : this.project.actualBudgetCost.budgetLines.find((l: any) => l.lineItemId == item.id);
        const actualDailyBudget = Array.isArray(reports) && reports.length
          ? reports
              .filter(x => x && x.budgetLines && x.budgetLines.some((bl: any) => bl.lineItemId == item.id))
              .map((x: any) => {
                const budgetLine = x.budgetLines.find((bl: any) => bl.lineItemId == item.id);
                return budgetLine && budgetLine.lineValue ? budgetLine.lineValue : 0;
              })
              .reduce((sum, value) => sum + value, 0)
          : 0;
        
        const varianceOption = this.selectedBudgetTableCostOption === "ActualDailyCumulativeCost" 
          ? actualDailyBudget 
          : actualBudgetLine ? actualBudgetLine.lineValue : 0;

        rows.push({
          id: item.id,
          lineItem: item.lineItem,
          sectionName: item.sectionName,
          lineSplit: item.lineSplit,
          plan: planBudgetLine ? planBudgetLine.lineValue : 0,
          actualBudgetCost: actualBudgetLine ? actualBudgetLine.lineValue : 0,
          actualDailyBudgetCost: actualDailyBudget,
          variance: planBudgetLine ? planBudgetLine.lineValue - (varianceOption ? varianceOption : 0) : 0,
          projectId: this.project.id,
          budgetTemplateId: budgetTemplate.id,
        });
      });

      return rows;
    },

    AfeLumpSumTableData() {
      let result:any = {rows:[],groupExtractor:undefined}
      const reports = this.ddrs.map((report: any) => {
        if (report.projectId == this.project.id) {
          return report.dailyTotalCost;
        }
        return null;
      });

      const totalDailyCost = reports.reduce((sum, value) => sum + value, 0);
      
      const varianceOption = this.selectedBudgetTableCostOption === "ActualDailyCumulativeCost" 
        ? totalDailyCost 
        : (this.project.afeCost ? this.project.afeCost : 0);

      result.rows.push({
          project: this.project.name,
          projectId: this.project.id,
          plan: Number(this.project.approvedAFEBudget ? this.project.approvedAFEBudget.toFixed(2) : 0),
          afeCost: Number(this.project.afeCost ? this.project.afeCost.toFixed(2) : 0),
          actualDailyCumulativeCost: Number(totalDailyCost && totalDailyCost != 0 && totalDailyCost != null ? totalDailyCost.toFixed(2) : 0),
          variance: Number(((this.project.approvedAFEBudget ? this.project.approvedAFEBudget : 0) - varianceOption).toFixed(2))
        });
      return result;
    }
  },
  methods: {
    showSidebar(tabIndex: number) {
      switch (tabIndex) {
        case 0:
          return true;
        case 1:
          return true;
        case 2:
          return this.project.costOption !== 'DailyCost' && this.project.costOption !== 'ProjectCost' ? true : false;
        case 3:
          return this.project.costOption !== 'DailyCost' && this.project.costOption !== 'ProjectCost' ? true : false;
        case 4:
          return false
      }
    },
    sortedActivitiesForProject() {
      const activities = this.$store.getters["ActivityModule/getNewActivitiesForProject"](this.projectId);
      return activities
      .sort((a:any, b:any) => {
          if (a.departmentId !== b.departmentId) {
              return parseInt(a.departmentId) - parseInt(b.departmentId);
          }
          return parseInt(a.operationUnitId) - parseInt(b.operationUnitId);
      });
    },
    downloadPlanningItemClicked(data:any){
      this.downloadFileClicked("PlanningItem",data.id)
    },
    uploadPlanningItemClicked(data:any){
      this.uploadFilesClicked("PlanningItem",data.id)
    },
    downloadFileClicked(model:string,meta:string=""){
      this.activeFileUploadAsscociatedModel = model
      this.activeFileUploadMeta = meta
      this.$bvModal.show('file-download-modal')
    },
    deleteFileClicked(fileId:any){
      this.$store.dispatch("FileModule/deleteFile",fileId)
    },
    setSplit(sourceBudget:any,budgetToUpdate:any){

    },
    onPrintKPISheetClicked(){
      this.$bvModal.show("print-kpi-sheet-modal")
    },
    onSelectedActivityChanged(){
       this.actvities.filter(a => this.selectedActivities.includes(a.id)).forEach(a => {
         if((a.budget==null) && (this.activeTemplates.length>0)) this.$store.dispatch("ActivityModule/updateActivityBudget",{projectIndex:this.getProjectIndexById,projectId:this.projectId,sequenceId:this.sequenceId,id:a,budgetTemplateId:this.activeTemplates[0]})
       })
    },
    onSelectedOperationChanged(operationUnitId:any){
      let selectedOperation = this.departments.find((d:any)=>d.id==this.selectedDepartmentId).operationUnits.find((t:any)=>t.id==operationUnitId)
      this.selectedOperationUnitId = selectedOperation.id
      this.selectedOperationUnitName = selectedOperation.name
      this.selectedActivities = []
      this.selectedTemplate = null
      this.$nextTick(()=>{
        this.selectedActivities = this.actvities.map(a=>a.id)
        this.onActivityChanged(this.selectedActivities);
        if (this.project) this.selectedCost = this.project.selectedCost;
        if(this.actvities.length>0){
          for(let i=0;i<this.actvities.length;i++){
            if(this.actvities[i].budget){
              this.selectedTemplate = this.actvities[i].budget.budgetTemplateId
              break;
            }
          }
          if(this.selectedTemplate&&this.selectedTemplate!=null){
            this.actvities.forEach(a => {
              if(!a.budget){
                this.$store.dispatch("ActivityModule/updateActivityBudget",{projectIndex:this.getProjectIndexById,projectId:this.projectId,sequenceId:this.sequenceId,id:a.id,budgetTemplateId:this.selectedTemplate})
              }
            })
          }
        }
      })
    },
    onDepartmentSelectionChanged(departmentId: any) {
      this.selectedDepartmentId = departmentId;
      let selectedOperationUnit = this.departments.find((d:any)=>d.id==departmentId).operationUnits[0]
      this.selectedOperationUnitId = selectedOperationUnit.id
      this.selectedOperationUnitName = selectedOperationUnit.name
      this.selectedActivities = []
      this.selectedTemplate = null
      if (this.project.costOption === 'LumpCost') {
        this.reloadDeptSheetTable ++;
        this.reloadDeptPerfTable ++;
      }
      //this.computeDepartmentalBudgetSum()
      //this.$store.commit('projectModule/setActiveProject', this.projectId);
      //this.$store.commit('projectModule/setActiveSequence', {sequenceId:this.sequenceId,readOnly:this.readOnlyView});

      this.$nextTick(()=>{
        this.selectedActivities = this.actvities.map(a=>a.id)
        this.onActivityChanged(this.selectedActivities);
        if (this.project) this.selectedCost = this.project.selectedCost;
        if(this.actvities.length>0){
          for(let i=0;i<this.actvities.length;i++){
            if(this.actvities[i].budget){
              this.selectedTemplate = this.actvities[i].budget.budgetTemplateId
              break;
            }
          }
          if(this.selectedTemplate&&this.selectedTemplate!=null){
            this.actvities.forEach(a => {
              if(!a.budget){
                this.$store.dispatch("ActivityModule/updateActivityBudget",{projectIndex:this.getProjectIndexById,projectId:this.projectId,sequenceId:this.sequenceId,id:a.id,budgetTemplateId:this.selectedTemplate})
              }
            })
          }
        }
      })
    },
    startButtonClicked() {
      this.$bvModal.show("budgetModel");
    },
    templateSelectionChanged(){
      if (this.project.costOption === 'ProjectCost') return;
      let templateId = this.selectedTemplate

      // if(this.previousYearQuarterTwoCompletionValues.budgetTemplateId!=templateId)this.$store.commit("BudgetModule/updateBudget",{id:this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ2C",budgetTemplateId:templateId})
      // if(this.previousYearQuarterTwoBudget.budgetTemplateId!=templateId)this.$store.commit("BudgetModule/updateBudget",{id:this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ2B",budgetTemplateId:templateId})
      // if(this.previousYearQuarterFourCompletionValues.budgetTemplateId!=templateId)this.$store.commit("BudgetModule/updateBudget",{id:this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ4C",budgetTemplateId:templateId})
      // if(this.previousYearQuarterFourBudget.budgetTemplateId!=templateId)this.$store.commit("BudgetModule/updateBudget",{id:this.selectedOperationUnitId+'*'+this.projectId+"*"+"PQ4B",budgetTemplateId:templateId})
      if(this.currentYearCompletionValues.budgetTemplateId!=templateId)this.$store.commit("BudgetModule/updateBudget",{id:this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYC",budgetTemplateId:templateId})
      if(this.currentYearBudget.budgetTemplateId!=templateId)this.$store.commit("BudgetModule/updateBudget",{id:this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYB",budgetTemplateId:templateId})
      if(this.currentYearReAllignedBudget.budgetTemplateId!=templateId)this.$store.commit("BudgetModule/updateBudget",{id:this.selectedOperationUnitId+'*'+this.projectId+"*"+"CYRB",budgetTemplateId:templateId})

      if(this.budgetLumpSum){
        this.selectedActivities.forEach((a:any) => {
          if(!a.budget||a.budget==null||a.budget.budgetTemplateId!=templateId)this.$store.dispatch("ActivityModule/updateActivityBudget",{projectIndex:this.getProjectIndexById,projectId:this.projectId,sequenceId:this.sequenceId,id:a,budgetTemplateId:templateId})
        });
      }

    },
    onLineValueChanged(data:any){
      let evaluationColumnIds = ["PQ2C","PQ2B","PQ4C","PQ4B","CYC","CYB","CYRB"]
      let isEvaluationData = evaluationColumnIds.findIndex(a=>(this.selectedOperationUnitId+'*'+this.projectId+"*"+a)==data.columnId)>-1
      if(isEvaluationData){
        this.$store.commit('BudgetModule/updateBudget',{id:data.columnId,sectionId:data.groupKey,lineItem:{lineValue:data.value,lineItemId:data.lineItemId}})
      }else{
        if(this.budgetLumpSum){
          this.$store.dispatch('ActivityModule/updateActivityBudget',{sequenceId:this.sequenceId,projectIndex:this.getProjectIndexById,id:data.columnId,sectionId:data.groupKey,lineItem:{lineValue:data.value,lineItemId:data.lineItemId}})
        }
      }
    },
    updateDepartmentBudget(data: any) {
        return this.$store.dispatch('departmentModule/updateDepartmentBudget', data)
    },

    updateProposedBudget(data: any) {
      let budgetLineIndex = this.project.proposedBudget ? this.project.proposedBudget.budgetLines.findIndex(
        (thisBudgetLine: any) =>
          thisBudgetLine.lineItemId == data.itemId
      ) : -1;

      //where the budget line index is not found, do a push into budget lines
      if (budgetLineIndex < 0) {
        if (this.project.proposedBudget === null) {
          const proposedBudget = {
            budgetTemplateId: Number(data.budgetTemplateId),
            budgetLines: [] as Array<any>,
            projectId: Number(this.project.id),
          };          
          this.project.proposedBudget = proposedBudget;
        }
        this.project.proposedBudget.budgetLines.push({
          lineValue: Number(data.proposedBudget),
          lineItemId: Number(data.itemId),
          lineSplit: data.lineSplit,
          lineItemName: data.lineItem,
          sectionName: data.sectionName,
        });        
      } else {
        this.project.proposedBudget.budgetLines[budgetLineIndex].lineValue = Number(data.proposedBudget);
      }
      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, proposedBudget: this.project.proposedBudget});
    },

    updateApprovedBudget(data: any) {
      let approveBudgetLineIndex = this.project.approvedBudget ? this.project.approvedBudget.budgetLines.findIndex(
        (thisBudgetLine: any) =>
          thisBudgetLine.lineItemId == data.itemId
      ) : -1;
      
      if (approveBudgetLineIndex < 0) {
        if (this.project.approvedBudget === null) {
          const approvedBudget = {
            budgetTemplateId: Number(data.budgetTemplateId),
            budgetLines: [] as Array<any>,
            projectId: Number(this.project.id),
          };
          this.project.approvedBudget = approvedBudget;
        }        
        this.project.approvedBudget.budgetLines.push({
          lineValue: Number(data.approvedBudget),
          lineItemId: Number(data.itemId),
          lineSplit: data.lineSplit,
          lineItemName: data.lineItem,
          sectionName: data.sectionName,
        });
      } else {
        this.project.approvedBudget.budgetLines[approveBudgetLineIndex].lineValue = Number(data.approvedBudget);
      }
      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, approvedBudget: this.project.approvedBudget});
    },

    updateRealignedBudget(data: any) {
      let realignedBudgetLineIndex = this.project.realignedBudget ? this.project.realignedBudget.budgetLines.findIndex(
        (thisBudgetLine: any) =>
          thisBudgetLine.lineItemId == data.itemId
      ) : -1;

      if (realignedBudgetLineIndex < 0) {
        if (this.project.realignedBudget === null) {
          const realignedBudget = {
            budgetTemplateId: Number(data.budgetTemplateId),
            budgetLines: [] as Array<any>,
              projectId: Number(this.project.id),
          };
          this.project.realignedBudget = realignedBudget;            
        }
        this.project.realignedBudget.budgetLines.push({
          lineValue: Number(data.realignedBudget),
          lineItemId: Number(data.itemId),
          lineSplit: data.lineSplit,
          lineItemName: data.lineItem,
          sectionName: data.sectionName,
        });
      } else {
        this.project.realignedBudget.budgetLines[realignedBudgetLineIndex].lineValue = Number(data.realignedBudget);        
      }
      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, realignedBudget: this.project.realignedBudget}); 
    },

    onProjectCostValueChanged(data: any){
      this.updateProposedBudget(data);
      this.updateApprovedBudget(data);
      this.updateRealignedBudget(data);
    },
    
    onLumpSumAFELineValueChanged(data: any){
      const approvedAFEBudget = data.approvedAFEBudget ? data.approvedAFEBudget : (this.project.approvedAFEBudget ? this.project.approvedAFEBudget : 0);
      const proposedAFEBudget = data.proposedAFEBudget ? data.proposedAFEBudget : (this.project.proposedAFEBudget ? this.project.proposedAFEBudget : 0);
      const realignedAFEBudget = data.realignedAFEBudget ? data.realignedAFEBudget : (this.project.realignedAFEBudget ? this.project.realignedAFEBudget : 0);

      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, approvedAFEBudget:approvedAFEBudget});
      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, proposedAFEBudget:proposedAFEBudget});
      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, realignedAFEBudget:realignedAFEBudget});
    },
    onProjectCostPerfLineValueChanged(data: any) {
      let actualBudgetCostLineIndex = this.project.actualBudgetCost ? this.project.actualBudgetCost.budgetLines.findIndex(
        (thisBudgetLine: any) =>
          thisBudgetLine.lineItemId == data.itemId
      ) : -1;

      if (actualBudgetCostLineIndex < 0) {
        if (this.project.actualBudgetCost === null) {
          const actualBudgetCost = {
            budgetTemplateId: Number(data.budgetTemplateId),
            budgetLines: [] as Array<any>,
            projectId: Number(this.project.id),
          };
          this.project.actualBudgetCost = actualBudgetCost;            
        }
        this.project.actualBudgetCost.budgetLines.push({
          lineValue: Number(data.actualBudgetCost),
          lineItemId: Number(data.itemId),
          lineSplit: data.lineSplit,
          lineItemName: data.lineItem,
          sectionName: data.sectionName,
        });
      } else {
        this.project.actualBudgetCost.budgetLines[actualBudgetCostLineIndex].lineValue = Number(data.actualBudgetCost);        
      }
      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, actualBudgetCost: this.project.actualBudgetCost}); 
    },
    onLumpSumAFEPerfLineValueChanged(data: any){
      const afeCost = data.afeCost ? data.afeCost : (this.project.afeCost ? this.project.afeCost : 0);

      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, afeCost:afeCost});
    },
    onDepartmentLineValueChanged(data: any){
      let budgetIndex = this.project.departmentBudgets && this.project.departmentBudgets.length > 0 ? this.project.departmentBudgets.findIndex(
        (thisBudget: any) =>
          thisBudget.departmentId == data.departmentId
      ) : -1;

      if (budgetIndex < 0) {
        this.project.departmentBudgets.push({
          departmentId: Number(data.departmentId),
          approvedBudget: data.approvedBudget,
          actualCost: data.actualCost,
          proposedBudget: data.proposedBudget,
          realignedBudget: data.realignedBudget,
        });
      } else {
        this.project.departmentBudgets[budgetIndex].departmentId = Number(data.departmentId);
        this.project.departmentBudgets[budgetIndex].approvedBudget = data.approvedBudget;
        this.project.departmentBudgets[budgetIndex].actualCost = data.actualCost;
        this.project.departmentBudgets[budgetIndex].proposedBudget = data.proposedBudget;
        this.project.departmentBudgets[budgetIndex].realignedBudget = data.realignedBudget;        
      }

      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, departmentBudgets: this.project.departmentBudgets});
    },

    onDepartmentPerformanceValueChanged(data: any){
      let budgetIndex = this.project.departmentBudgets && this.project.departmentBudgets.length > 0 ? this.project.departmentBudgets.findIndex(
        (thisBudget: any) =>
          thisBudget.departmentId == data.departmentId
      ) : -1;
      window.console.log(budgetIndex, 'budgetIndex');
      if (budgetIndex < 0) {
        this.project.departmentBudgets.push({
          departmentId: Number(data.departmentId),
          approvedBudget: 0,
          actualCost: data.actualCost,
          proposedBudget: 0,
          realignedBudget: 0,
        });
      } else {
        this.project.departmentBudgets[budgetIndex].actualCost = data.actualCost;        
      }

      this.$store.commit('projectModule/updateProject',{sequenceId:this.project.sequenceId, id:this.project.id, departmentBudgets: this.project.departmentBudgets});
    },
    onActualBudgetLineValueChanged(data:any){
      this.$store.dispatch('ActivityModule/updateActivityActualBudget',{sequenceId:this.sequenceId,projectIndex:this.getProjectIndexById,id:data.columnId,sectionId:data.groupKey,lineItem:{lineValue:data.value,lineItemId:data.lineItemId}})
    },
    onSelectedCostChange() {
      this.$store.commit('projectModule/updateProject',{sequenceId: this.sequenceId, id:this.project.id, selectedCost: this.selectedCost})
    },
    addActivity(data:any){
      if(data=='show-activity-form'){
        this.$bvModal.show("new-activity-modal")
      }else{
        this.$store.dispatch("ActivityModule/addActivity",{sequenceId:this.sequenceId,projectIndex:this.getProjectIndexById ,newActivity:{
            name:this.activity.name,
            departmentId:this.selectedDepartmentId,
            start:this.activity.start,
            end:this.activity.end,
            milestones:[],
            operationUnitId:this.selectedOperationUnitId,
            wellActivity:this.getWellActivities.find((wa:any) => wa.id == this.activity.wellActivity)
        }})
      }
    },
    addMilestone(data:any){
      if(data=='show-milestone-form'){
        this.$bvModal.show("new-milestone-modal")
      }else{
        this.$store.commit('ActivityModule/setActiveActivity', this.milestone.parentActivityId);
        this.$store.commit('MilestoneModule/setActivityId', this.milestone.parentActivityId);
        this.$nextTick(()=>{
          let milestoneToAdd = {
            name: this.milestone.name,
            start: this.milestone.start,
            end: this.milestone.end,
            startDepth:0,
            endDepth:0,
            code:this.milestone.code,
            dailyOperations:[],
            description: "",
            parentActivityId:this.milestone.parentActivityId
          }
          this.$store.commit('MilestoneModule/addMilestoneToActivity',milestoneToAdd)
        })
      }
    },

    onActivityChanged(activities:Array<any>) {
      activities.forEach((id) => {
          HTTP.get('activities/?projectId=' + this.projectId)
          .then((response: any) => {
            const activitity = response.data.data.find((x:any) => x.id === id)
            if (activitity && activitity.start === null && activitity.milestones.length === 0) {
              const activity = this.actvities.find(x => x.id === id)
              if (activity && activity.start === null && activity.milestones.length === 0) {
                  this.addPseudoMilestone(activity);
              }
            }
          })
      })
    },

    addPseudoMilestone(data:any) {
      let milestoneToAdd = {
        name: data.name,
        start: null,
        end: null,
        startDepth: 0,
        endDepth: 0,
        selectedOption: "Duration",
        duration: 0,
        code: data.name,
        dailyOperations: [],
        description: "",
        parentActivityId: data.id
      }
      this.$store.commit('MilestoneModule/addMilestoneToActivity',milestoneToAdd)
    },

    addContract(data:any){
      if(data=='show-workorder-form'){
        this.$bvModal.show("new-workorder-modal")
      }
    },
    saveActualCost(){
      HTTP.post("budgets/actualcost",{operationUnitId:this.selectedOperationUnitId,projectId:this.projectId,actualCostValue:this.currentActualCost})
      .then(()=>{
        this.currentActualCost = 0
      })
    },

    uploadFilesClicked(associatedModel:string,meta:string){
      this.budgetUploadState = "IDLE"
      this.activeFileUploadAsscociatedModel = associatedModel
      this.activeFileUploadMeta = meta
      this.$bvModal.show('file-upload-modal')
    },

    handleFilesUpload(){
      let fileInputElement = this.$refs.fileinputelement as any
      if(fileInputElement.files.length>0){
        this.currentUploadedBudgetFile = fileInputElement.files[0] as any;
        if(this.currentUploadedBudgetFile!=null)this.currentUploadedBudgetFileName = fileInputElement.files[0].name
      }
    },

    clearFileUploadSelection(){
      this.currentUploadedBudgetFile = ""
      this.currentUploadedBudgetFileName = ""
      this.currentUploadedBudgetFileDescription = ""
    },

    doFileUpload(){
      let formData = new FormData();
      formData.append('file',this.currentUploadedBudgetFile)
      formData.append('fileName',this.currentUploadedBudgetFileName)
      formData.append('fileDescription', this.currentUploadedBudgetFileDescription)
      formData.append('projectId',this.projectId)
      formData.append('operationUnitId',this.selectedOperationUnitId.toString())
      formData.append('departmentId',this.selectedDepartmentId.toString())
      formData.append('associatedModel',this.activeFileUploadAsscociatedModel)
      formData.append('meta',this.activeFileUploadMeta)
      this.budgetUploadState = "BUSY"
      this.$store.dispatch("FileModule/uploadFile",formData).then((res:any) => {
        this.budgetUploadState = "SUCCESS"
        this.activeFileUploadAsscociatedModel = ""
        this.activeFileUploadMeta = ""
        this.clearFileUploadSelection()
      })
      .catch((err:any) => {
        this.budgetUploadState = "FAILED"
      })
    },

    downloadFile(fileId:any,fileName:string,fileType:string){
      this.$store.dispatch("FileModule/downloadFile",{fileId,fileName,fileType})
    },   

    getMilestoneById(id: any){
      return this.$store.getters["MilestoneModule/getMilestoneById"](id)
    },
  },

  mounted() {
    this.$store.dispatch("ActivityModule/fetchActivities", this.projectId);
    if (this.budgetTemplateOptions.length < 1) {
      this.$store.dispatch("budgetTemplateModule/fetchBudgetTemplates");
    }
    if(this.allBudgetLineItems.length==0) this.$store.dispatch("budgetLineModule/fetchBudgetLines")
    if(this.getBudgetTemplates && this.getBudgetTemplates.length<1){
      this.$store.dispatch("budgetTemplateModule/fetchBudgetTemplates")
    }
    if(this.$store.state.BudgetModule.budget.length<1){
      this.$store.dispatch("BudgetModule/getBudgets")
    }
    
    this.$store.dispatch('departmentModule/getDepartments');

    this.selectedOperationUnitId = this.departments[0].operationUnits[0].id
    this.onDepartmentSelectionChanged(this.departments[0].id)
    if(this.actvities.length>0)this.selectedActivities.push(this.actvities[0].id)
    this.$store.dispatch("DailyReportModule/getReportsForProject", this.projectId)

    this.projectYear = new Date(this.project.start).getFullYear()
    this.activeProjectConversionFactor = this.sequence.annualizedBudgets.find((a:any) => a.year == this.projectYear).exchangeRate
    this.lineSplit = this.project.lineSplit && (this.project.lineSplit != null || this.project.lineSplit != 0) ? this.project.lineSplit : 1
    if (this.project.costOption === 'ProjectCost' && this.project.approvedBudget && this.project.approvedBudget != null) {
      this.selectedTemplate = this.project.approvedBudget.budgetTemplateId;
    }
  },

  activated() {
    this.$store.dispatch("DailyReportModule/getReportsForProject", this.projectId)
    this.$store.dispatch("ActivityModule/fetchActivities", this.projectId);
    this.milestoneActivity;
    if (this.project.costOption === 'ProjectCost' && this.project.approvedBudget && this.project.approvedBudget != null) {
      this.selectedTemplate = this.project.approvedBudget.budgetTemplateId;
    }
  }
});

